import React, { useCallback } from 'react'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import AdditionalCosts from '../../fields/additionalCosts/AdditionalCosts'
import Deposit from '../../fields/deposit/Deposit'

import CostCalculationBox from '../../../../../../common/display/costCalculationBox/CostCalculationBox'
import Costs from '../../Costs'
import MoveInDate from '../../../commonFields/moveInDate/MoveInDate'
import ToggledInputFields from '../../../../../../common/inputs/toggledInputFields/ToggledInputFields'
import HeatingCosts from '../../fields/heatingCosts/HeatingCosts'
import { InsertionFlowScreensProps } from '../../../../../../../@types/props-types'
import { PriceFieldType } from '../../../basicInfo/fields/priceField/PriceField'
import CourtageGroup from '../../fields/courtageGroup/CourtageGroup'
import { DefaultRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'
import { SCREEN_COSTS, SCREENS } from '../../../../../../../services/domain/wizardScreens'

export type CostsApartmentRentProps = {
  showMoveInDate: boolean
  showCourtage?: boolean
  screenTooltipKey?: string
}

const ResidentialCostsRent: React.FC<
  InsertionFlowScreensProps<CostsScreenValidationResult> & CostsApartmentRentProps
> = (props) => {
  const heatingCostOptionChanged = useCallback(
    (value: boolean) => {
      props.doReset!([{ screen: SCREENS[SCREEN_COSTS].name, property: 'heatingCosts' }])
      props.onChange({ screen: SCREENS[SCREEN_COSTS].name, property: 'heatingCostsOption' }, value)
    },
    [props]
  )

  return (
    <Costs {...props}>
      {(costsWrapperProps) => (
        <>
          <div className='grid grid-flex'>
            <div className='grid-item palm-one-whole two-fifth'>
              <AdditionalCosts {...costsWrapperProps} />
              <Deposit {...costsWrapperProps} />
              {props.showMoveInDate && <MoveInDate {...costsWrapperProps} />}
            </div>
            <div className='grid-item palm-one-whole three-fifth palm-margin-vertical-xl palm-padding-left-none padding-left-xl padding-top-m palm-margin-horizontal-xxl palm-order-one-down'>
              <CostCalculationBox
                additionalCostsValue={costsWrapperProps.insertionData.additionalCosts}
                priceValue={costsWrapperProps.insertionData.price}
                priceFieldType={PriceFieldType.COLD_RENT}
                priceType={costsWrapperProps.insertionData.priceType?.value as DefaultRentPriceTypeOption}
                {...(costsWrapperProps.insertionData.heatingCostsOption === false && {
                  heatingCostsValue: costsWrapperProps.insertionData.heatingCosts ?? '0',
                })}
              />
            </div>
            <div className='grid-item one-whole margin-top-l'>
              <ToggledInputFields
                screenId={costsWrapperProps.screenId!}
                elementId='heating-costs'
                propertyName='heatingCostsOption'
                toggleStatus={costsWrapperProps.insertionData.heatingCostsOption ?? true}
                displayChildrenOnToggleState={false}
                hasSubtitle={true}
                customYAxisOffset={68}
                onChange={heatingCostOptionChanged}
              >
                <HeatingCosts
                  screenId={costsWrapperProps.screenId!}
                  heatingCosts={costsWrapperProps.insertionData.heatingCosts}
                  heatingCostsValidation={costsWrapperProps.validationMessages!.heatingCosts ?? []}
                  onChange={(property, value) =>
                    costsWrapperProps.onChange({ screen: costsWrapperProps.screenName, property }, value)
                  }
                />
              </ToggledInputFields>
            </div>
            {props.showCourtage && (
              <div className='grid-item one-whole margin-top-l'>
                <CourtageGroup {...costsWrapperProps} />
              </div>
            )}
          </div>
        </>
      )}
    </Costs>
  )
}

export default ResidentialCostsRent
